// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Privacy & data  (API for pages/PrivacyData.tsx)
// "Erase my data" (Privacy Policy §14): POST /api/me/data-requests/erasure records a request — nothing is deleted automatically; a
// person at ZenFresh reviews it (order and payment records may have to be kept for tax and consumer-protection law, §8) and marks it
// completed or declined with a note. GET returns the customer's request, if any. Backend: `dataRequests/erasure-{uid}`.
// ─────────────────────────────────────────────────────────────────────────────
import { apiAuthed } from "./api";

export interface ErasureRequest {
  status: "open" | "completed" | "declined";
  createdAt: string;
  note: string | null;
  resolvedAt: string | null;
  resolutionNote: string | null;
}

export const MAX_NOTE = 500;

export const fetchErasure = () => apiAuthed<{ request: ErasureRequest | null }>("GET", "/me/data-requests/erasure");

export const requestErasure = (note: string) => apiAuthed<ErasureRequest>("POST", "/me/data-requests/erasure", note.trim() ? { note: note.trim() } : {});
